import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { addCompanyInterview, updateCompanyInterview, deleteCompanyInterview } from "./EmployerInterviewAPI"

const initialState = {
  data: [],
  loading: false,
  error: null,
}

export const addCompanyInterviewsAsync = createAsyncThunk(
  "CompanyInterview/add",
  async (newData, { rejectWithValue }) => {
    try {
      return await addCompanyInterview(newData)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const updateCompanyInterviewAsync = createAsyncThunk(
  "CompanyInterview/update",
  async ({ uuid, updatedData }, { rejectWithValue }) => {
    try {
      return await updateCompanyInterview(uuid, updatedData)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const deleteCompanyInterviewAsync = createAsyncThunk(
  "CompanyInterview/delete",
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteCompanyInterview(uuid)
      return uuid
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const CompanyInterviewSlice = createSlice({
  name: "companyInterview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCompanyInterviewsAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(addCompanyInterviewsAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data?.push(action.payload)
      })
      .addCase(addCompanyInterviewsAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(updateCompanyInterviewAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(updateCompanyInterviewAsync.fulfilled, (state, action) => {
        state.loading = false
        const index = state.data.findIndex((item) => item.uuid === action.payload.uuid)
        if (index !== -1) {
          state.data[index] = action.payload
        }
      })
      .addCase(updateCompanyInterviewAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(deleteCompanyInterviewAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteCompanyInterviewAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = state.data.filter((item) => item.uuid !== action.payload)
      })
      .addCase(deleteCompanyInterviewAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const selectCompanyInterview = (state) => state.companyInterview.data
export default CompanyInterviewSlice.reducer